import { nativeShell } from './bridge';

/**
 * The system share sheet, wherever there is one: the shell's plugin in a native
 * build, the Web Share API on a phone browser, and nothing on a desktop browser
 * — where a copied link is already the shorter path.
 */

interface ShareCapableNavigator {
  share?: (data: { title?: string; text?: string; url?: string }) => Promise<void>;
}

export function canSystemShare(): boolean {
  return !!nativeShell()?.share || typeof (navigator as ShareCapableNavigator).share === 'function';
}

/** Offer `url` to the system. False when there is nothing to offer it to, or the user backed out. */
export async function systemShare(payload: { title?: string; url: string }): Promise<boolean> {
  const shell = nativeShell();
  if (shell?.share) return shell.share({ title: payload.title, text: payload.url });

  const share = (navigator as ShareCapableNavigator).share;
  if (!share) return false;
  try {
    await share({ title: payload.title, url: payload.url });
    return true;
  } catch {
    // Dismissing the sheet rejects; that is not an error worth showing.
    return false;
  }
}
